import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Select } from 'antd';
import { api } from '../../../../config/api';

const { Option } = Select;

const Pagamento = ({
  isVisible,
  onClose,
  precoTotal,
  setPagamentoConcluido,
  setPagItem,
  pagamentos,
  setPagamentos,
  idLoja,
}) => {

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");

  const [restauranteId, setRestauranteId] = useState('');
  const [formasDePagamento, setFormasDePagamento] = useState([]);
  const [totalPago, setTotalPago] = useState(0);
  const [valor, setValor] = useState('');


  useEffect(() => {
    if (accessToken && idUser) {
      axios
        .get(`${api.techfood}/v1/restaurantes/usuario/${idUser}`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .then((response) => setRestauranteId(response.data.id));
    }
  }, [accessToken, idUser]);

  useEffect(() => {
    if (restauranteId) {
      axios
        .get(
          `${api.techspdv}/v1/restaurantes/${restauranteId}/formas-pagamento`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
        .then((response) => {
          const options = response.data._embedded.formasPagamento.map((forma) => ({
            label: forma.descricao,
            value: forma.codigo,
          }));
          setFormasDePagamento(options);
        });
    }
  }, [restauranteId]);

  const handleValorChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, '');
    const formattedValue = parseFloat(numericValue / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    setValor(formattedValue);
  };

  const adicionarPagamento = () => {
    const valorNumerico = parseFloat(valor.replace(/[^0-9,-]+/g, '').replace(',', '.'));
    if (valorNumerico + totalPago <= precoTotal) {
      setPagamentos((prev) => [
        ...prev,
        { tipo: '01', tipoNome: 'Dinheiro', valor: valorNumerico },
      ]);
      setTotalPago((prev) => prev + valorNumerico);
    }
  };

  const confirmarPagamento = () => {
    setPagamentoConcluido(true);
    setPagItem(pagamentos.map((pag) => ({
      tPag: pag.tipo,
      vPag: pag.valor,
      xPag: pag.tipoNome,
    })));
    onClose();
  };

  const estiloContainerPagamento = {
    display: isVisible ? 'block' : 'none',
    width: '100%',
    maxWidth: '760px',
    margin: '0 auto',
    padding: '18px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.10)',
    boxSizing: 'border-box',
  };

  const estiloCabecalhoPagamento = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    paddingBottom: '14px',
    marginBottom: '14px',
    borderBottom: '1px solid #e5e7eb',
  };

  const estiloTituloPagamento = {
    margin: 0,
    color: '#111827',
    fontSize: '22px',
    fontWeight: '800',
  };

  const estiloDescricaoPagamento = {
    display: 'block',
    marginTop: '3px',
    color: '#6b7280',
    fontSize: '13px',
  };

  const estiloGridPagamento = {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1.4fr) minmax(180px, 0.8fr)',
    gap: '12px',
    alignItems: 'end',
  };

  const estiloCardSecao = {
    padding: '14px',
    background: '#f8fafc',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    boxSizing: 'border-box',
  };

  const estiloCampo = {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    width: '100%',
  };

  const estiloLabel = {
    color: '#374151',
    fontSize: '12px',
    fontWeight: '700',
  };

  const estiloInputValor = {
    width: '100%',
    height: '42px',
    padding: '0 12px',
    background: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '9px',
    color: '#111827',
    fontSize: '14px',
    outline: 'none',
    boxSizing: 'border-box',
  };

  const estiloResumo = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '12px',
    marginTop: '12px',
  };

  const estiloCardResumo = {
    padding: '14px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    boxSizing: 'border-box',
  };

  const estiloLabelResumo = {
    display: 'block',
    marginBottom: '5px',
    color: '#6b7280',
    fontSize: '12px',
    fontWeight: '700',
  };

  const estiloValorResumo = {
    margin: 0,
    color: '#111827',
    fontSize: '20px',
    fontWeight: '800',
  };

  const estiloRodapePagamento = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    paddingTop: '15px',
    marginTop: '14px',
    borderTop: '1px solid #e5e7eb',
  };

  const estiloBotaoBase = {
    minHeight: '42px',
    padding: '9px 18px',
    borderRadius: '9px',
    fontSize: '14px',
    fontWeight: '800',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  };

  const estiloBotaoAdicionar = {
    ...estiloBotaoBase,
    width: '100%',
    marginTop: '12px',
    border: '1px solid #1d4ed8',
    background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
    color: '#ffffff',
    boxShadow: '0 5px 12px rgba(37, 99, 235, 0.22)',
  };

  const estiloBotaoConfirmar = {
    ...estiloBotaoBase,
    minWidth: '130px',
    border: '1px solid #15803d',
    background: 'linear-gradient(135deg, #22c55e, #15803d)',
    color: '#ffffff',
    boxShadow: '0 5px 12px rgba(34, 197, 94, 0.20)',
  };

  const estiloBotaoFechar = {
    ...estiloBotaoBase,
    minWidth: '100px',
    border: '1px solid #d1d5db',
    background: '#ffffff',
    color: '#374151',
  };


  return (
    <div style={estiloContainerPagamento}>
      <div style={estiloCabecalhoPagamento}>
        <div>
          <h2 style={estiloTituloPagamento}>
            Pagamento
          </h2>

          <span style={estiloDescricaoPagamento}>
            Selecione a forma e informe o valor recebido.
          </span>
        </div>

        <span
          style={{
            fontSize: '30px',
            lineHeight: 1,
          }}
        >
          💳
        </span>
      </div>

      <div style={estiloCardSecao}>
        <div style={estiloGridPagamento}>
          <div style={estiloCampo}>
            <label style={estiloLabel}>
              Forma de pagamento
            </label>

            <Select
              style={{ width: '100%' }}
              placeholder="Selecione a forma de pagamento"
              onChange={(value) => console.log(value)}
            >
              {formasDePagamento.map((forma) => (
                <Option
                  key={forma.value}
                  value={forma.value}
                >
                  {forma.label}
                </Option>
              ))}
            </Select>
          </div>

          <div style={estiloCampo}>
            <label style={estiloLabel}>
              Valor recebido
            </label>

            <input
              type="text"
              value={valor}
              onChange={handleValorChange}
              placeholder="Digite o valor"
              style={estiloInputValor}
            />
          </div>
        </div>

        <button
          type="button"
          onClick={adicionarPagamento}
          style={estiloBotaoAdicionar}
        >
          ＋ Adicionar pagamento
        </button>
      </div>

      <div style={estiloResumo}>
        <div style={estiloCardResumo}>
          <span style={estiloLabelResumo}>
            Total da venda
          </span>

          <h3 style={estiloValorResumo}>
            {precoTotal.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </h3>
        </div>

        <div style={estiloCardResumo}>
          <span style={estiloLabelResumo}>
            Total pago
          </span>

          <h3 style={estiloValorResumo}>
            {totalPago.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            })}
          </h3>
        </div>
      </div>

      <div style={estiloRodapePagamento}>
        <button
          type="button"
          onClick={onClose}
          style={estiloBotaoFechar}
        >
          Fechar
        </button>

        <button
          type="button"
          onClick={confirmarPagamento}
          style={estiloBotaoConfirmar}
        >
          ✓ Confirmar
        </button>
      </div>
    </div>
  );
};



export default Pagamento;
